(function () {
  "use strict";

  const SELECTORS = {
    productContainer: "[data-js-product-container]",
    complementaryProducts: ".js-complementary-products",
    productForm: "[data-js-product-form]",
    productJson: "[data-js-product-json]",
    productOption: "[data-option]",
    variantId: '[name="id"]',
    priceContainer: ".js-price",
    productPrice: "[data-product-price]",
    productPriceOld: "[data-price-old]",
    productPriceDiscount: "[data-product-price-discount]",
    unitPrice: "[data-js-unit-price]",
    quickView: ".js-quick-view",
    quickViewForm: ".js-quick-view-form",
    quickViewVariants: ".js-quick-view-variants",
    quickViewHiddenSelect: ".js-quick-view-hidden-select",
    quickViewPrice: ".js-quick-view-price .js-price",
  };

  const CLASSES = {
    onSale: "price--on-sale",
    hidePrice: "price--hide",
    hidden: "is-hidden",
  };

  const ATTRIBUTES = {
    currencyCodeEnabled: "data-currency-code-enabled",
  };

  function getThemeCore() {
    return window.themeCore &&
      window.themeCore.utils &&
      window.themeCore.objects
      ? window.themeCore
      : null;
  }

  function formatMoney(amount, withCurrency) {
    const themeCore = getThemeCore();
    if (!themeCore || typeof themeCore.utils.formatMoney !== "function") {
      return "";
    }

    const shop = themeCore.objects.shop || {};
    const format = withCurrency
      ? shop.money_with_currency_format
      : shop.money_format;
    return themeCore.utils.formatMoney(amount, format || "${{amount}}");
  }

  function parseJson(element) {
    if (!element) {
      return null;
    }

    try {
      return JSON.parse(element.textContent || element.innerHTML || "null");
    } catch (error) {
      return null;
    }
  }

  function getPriceElements(priceContainer) {
    let productPrice = priceContainer.querySelectorAll(SELECTORS.productPrice);
    let productPriceOld = priceContainer.querySelectorAll(
      SELECTORS.productPriceOld,
    );

    if (!productPrice.length) {
      productPrice = priceContainer.querySelectorAll(
        ".price__sale .price-item--sale",
      );
    }
    if (!productPrice.length) {
      productPrice = priceContainer.querySelectorAll(".price-item--sale");
    }
    if (!productPrice.length) {
      productPrice = priceContainer.querySelectorAll(
        ".price__regular .price-item--regular",
      );
    }
    if (!productPriceOld.length) {
      productPriceOld = priceContainer.querySelectorAll(
        ".price__old .price-item--regular",
      );
    }

    return {
      productPrice: Array.prototype.slice.call(productPrice),
      productPriceOld: Array.prototype.slice.call(productPriceOld),
    };
  }

  function updateUnitPrice(priceContainers, variant) {
    priceContainers.forEach(function (priceContainer) {
      const unitPriceNodes = Array.prototype.slice.call(
        priceContainer.querySelectorAll(SELECTORS.unitPrice),
      );
      if (!unitPriceNodes.length) {
        return;
      }

      const unitPriceContainer = unitPriceNodes.find(function (element) {
        return element.dataset.jsUnitPrice === "container";
      });
      const unitPriceMoney = unitPriceNodes.find(function (element) {
        return element.dataset.jsUnitPrice === "money";
      });
      const unitPriceReference = unitPriceNodes.find(function (element) {
        return element.dataset.jsUnitPrice === "reference";
      });
      const variantUnitPrice = variant && variant.unit_price;
      const variantUnitPriceMeasurement =
        variant && variant.unit_price_measurement;

      if (unitPriceMoney) {
        unitPriceMoney.innerHTML = variantUnitPrice
          ? formatMoney(variantUnitPrice, false)
          : "";
      }

      if (unitPriceReference) {
        if (variantUnitPriceMeasurement) {
          const referenceValue = variantUnitPriceMeasurement.reference_value;
          const referenceUnit =
            variantUnitPriceMeasurement.reference_unit || "";
          unitPriceReference.innerHTML =
            (referenceValue !== 1 ? referenceValue : "") + referenceUnit;
        } else {
          unitPriceReference.innerHTML = "";
        }
      }

      if (unitPriceContainer) {
        unitPriceContainer.classList.toggle(CLASSES.hidden, !variantUnitPrice);
      }
    });
  }

  function updatePriceContainers(priceContainers, variant) {
    if (!priceContainers.length) {
      return;
    }

    if (!variant) {
      priceContainers.forEach(function (priceContainer) {
        priceContainer.classList.add(CLASSES.hidePrice);
      });
      updateUnitPrice(priceContainers, null);
      return;
    }

    priceContainers.forEach(function (priceContainer) {
      const withCurrency = priceContainer.hasAttribute(
        ATTRIBUTES.currencyCodeEnabled,
      );
      const price = variant.price;
      const compareAtPrice = variant.compare_at_price;
      const onSale =
        typeof compareAtPrice === "number" && compareAtPrice > price;
      const moneyPrice = formatMoney(price, withCurrency);
      const moneyPriceOld = onSale
        ? formatMoney(compareAtPrice, withCurrency)
        : "";
      const discountElement = priceContainer.querySelector(
        SELECTORS.productPriceDiscount,
      );
      const priceElements = getPriceElements(priceContainer);

      priceContainer.classList.remove(CLASSES.hidePrice);
      priceContainer.classList.toggle(CLASSES.onSale, onSale);

      priceElements.productPrice.forEach(function (element) {
        element.innerHTML = moneyPrice;
        if (element.hasAttribute("data-amount")) {
          element.setAttribute("data-amount", price);
        }
      });

      priceElements.productPriceOld.forEach(function (element) {
        element.innerHTML = moneyPriceOld;
      });

      if (discountElement) {
        if (onSale && compareAtPrice > 0) {
          const discountPercentage = Math.ceil(
            ((compareAtPrice - price) / compareAtPrice) * 100,
          );
          discountElement.innerHTML = "-" + discountPercentage + "%";
          discountElement.classList.remove(CLASSES.hidden);
          discountElement.hidden = false;
        } else {
          discountElement.innerHTML = "";
          discountElement.classList.add(CLASSES.hidden);
          discountElement.hidden = true;
        }
      }
    });

    updateUnitPrice(priceContainers, variant);
  }

  function getVariantFromProductForm(container) {
    const form = container.querySelector(SELECTORS.productForm);
    const product = parseJson(container.querySelector(SELECTORS.productJson));

    if (!form || !product || !Array.isArray(product.variants)) {
      return null;
    }

    const formData = new FormData(form);
    const optionKeys = Array.from(formData.keys()).filter(function (key) {
      return key.indexOf("option") === 0;
    });
    const options = {};

    optionKeys.forEach(function (key) {
      options[key] = formData.get(key);
    });

    if (
      Object.keys(options).some(function (key) {
        return options[key];
      })
    ) {
      return (
        product.variants.find(function (variant) {
          return Object.keys(options).every(function (key) {
            return variant[key] === options[key];
          });
        }) || null
      );
    }

    const variantId = formData.get("id");
    if (!variantId) {
      return null;
    }

    return (
      product.variants.find(function (variant) {
        return Number(variantId) === variant.id;
      }) || null
    );
  }

  function syncProductContainer(container) {
    if (!container) {
      return;
    }

    const priceContainers = Array.prototype.slice
      .call(container.querySelectorAll(SELECTORS.priceContainer))
      .filter(function (el) {
        return !el.closest(SELECTORS.complementaryProducts);
      });
    const variant = getVariantFromProductForm(container);
    updatePriceContainers(priceContainers, variant);
  }

  function getQuickViewVariant(quickView) {
    const variants = parseJson(
      quickView.querySelector(SELECTORS.quickViewVariants),
    );
    const hiddenSelect = quickView.querySelector(
      SELECTORS.quickViewHiddenSelect,
    );

    if (!Array.isArray(variants) || !hiddenSelect || !hiddenSelect.value) {
      return null;
    }

    return (
      variants.find(function (variant) {
        return variant.id === Number(hiddenSelect.value);
      }) || null
    );
  }

  function syncQuickView(quickView) {
    if (!quickView) {
      return;
    }

    const priceContainers = Array.prototype.slice.call(
      quickView.querySelectorAll(SELECTORS.quickViewPrice),
    );
    const variant = getQuickViewVariant(quickView);
    updatePriceContainers(priceContainers, variant);
  }

  function handleChange(event) {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const quickViewForm = target.closest(SELECTORS.quickViewForm);
    if (
      quickViewForm &&
      (target.matches(SELECTORS.productOption) ||
        target.matches(SELECTORS.variantId))
    ) {
      window.setTimeout(function () {
        syncQuickView(quickViewForm.closest(SELECTORS.quickView));
      }, 0);
      return;
    }

    const productContainer = target.closest(SELECTORS.productContainer);
    if (
      productContainer &&
      (target.matches(SELECTORS.productOption) ||
        target.matches(SELECTORS.variantId))
    ) {
      window.setTimeout(function () {
        syncProductContainer(productContainer);
      }, 0);
    }
  }

  function handleQuickViewLoaded() {
    const quickView = document.querySelector(SELECTORS.quickView);
    if (!quickView) {
      return;
    }

    syncQuickView(quickView);
  }

  function init() {
    document.addEventListener("change", handleChange);
    document.addEventListener("product:variant:change", function () {
      const containers = Array.prototype.slice.call(
        document.querySelectorAll(SELECTORS.productContainer),
      );
      containers.forEach(syncProductContainer);
    });
    document.addEventListener("theme:all:loaded", handleQuickViewLoaded);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
